"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBCsrfXhr = void 0;
var auth_1 = require("../auth");
var auth_domain_1 = require("../auth/auth-domain");
var navigator_1 = require("./navigator");
function post(url, header, body, okCB, unuthCB) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            switch (xhr.status) {
                case 0:
                    unuthCB({
                        code: auth_1.BBAuthTokenErrorCode.Offline,
                        message: 'The user is offline.',
                    });
                    break;
                case 200:
                    okCB(xhr.responseText);
                    break;
                case 401:
                    unuthCB({
                        code: auth_1.BBAuthTokenErrorCode.NotLoggedIn,
                        message: 'The user is not logged in.',
                    });
                    break;
                case 403:
                    unuthCB({
                        code: auth_1.BBAuthTokenErrorCode.InvalidEnvironment,
                        message: 'The user is not a member of the specified environment.',
                    });
                    break;
                default:
                    /* istanbul ignore else */
                    if (xhr.status >= 400) {
                        unuthCB({
                            code: auth_1.BBAuthTokenErrorCode.Unspecified,
                            message: 'An unknown error occurred.',
                        });
                    }
                    break;
            }
        }
    };
    xhr.open('POST', url, true);
    xhr.setRequestHeader(header.name, header.value);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.withCredentials = true;
    if (body) {
        xhr.send(JSON.stringify(body));
    }
    else {
        xhr.send();
    }
}
function addToRequestBody(body, key, value, condition) {
    if (condition || (condition === undefined && value)) {
        body = body || {};
        body[key] = value;
    }
    return body;
}
function requestToken(url, csrfValue, envId, permissionScope, leId, svcId) {
    var body;
    body = addToRequestBody(body, 'environment_id', envId);
    body = addToRequestBody(body, 'legal_entity_id', leId);
    body = addToRequestBody(body, 'permission_scope', permissionScope, !!((envId || leId) && permissionScope));
    body = addToRequestBody(body, 'svc_id', svcId, !!((envId || leId) && svcId));
    return new Promise(function (resolve, reject) {
        post(url, {
            name: 'X-CSRF',
            value: csrfValue,
        }, body, function (text) {
            var response = text ? JSON.parse(text) : undefined;
            resolve(response);
        }, reject);
    });
}
var BBCsrfXhr = /** @class */ (function () {
    function BBCsrfXhr() {
    }
    BBCsrfXhr.request = function (url, signinRedirectParams, disableRedirect, envId, permissionScope, leId, bypassCsrf, svcId) {
        if (permissionScope && !envId && !leId) {
            return Promise.reject({
                code: auth_1.BBAuthTokenErrorCode.PermissionScopeNoEnvironment,
                message: 'You must also specify an environment or legal entity when specifying a permission scope.',
            });
        }
        return new Promise(function (resolve, reject) {
            // First get the CSRF token
            new Promise(function (resolveCsrf, rejectCsrf) {
                if (bypassCsrf) {
                    resolveCsrf({
                        csrf_token: 'token_needed',
                    });
                }
                else {
                    requestToken(auth_domain_1.BBAuthDomain.getSTSDomain() + '/session/csrf', 'token_needed')
                        .then(resolveCsrf)
                        .catch(rejectCsrf);
                }
            })
                .then(function (csrfResponse) {
                // Next get the access token, and then pass it to the callback.
                return requestToken(url, csrfResponse['csrf_token'], envId, permissionScope, leId, svcId);
            })
                .then(resolve)
                .catch(function (reason) {
                if (disableRedirect || reason.code === auth_1.BBAuthTokenErrorCode.Offline) {
                    reject(reason);
                }
                else {
                    switch (reason.code) {
                        case auth_1.BBAuthTokenErrorCode.NotLoggedIn:
                            navigator_1.BBAuthNavigator.redirectToSignin(signinRedirectParams);
                            break;
                        default:
                            navigator_1.BBAuthNavigator.redirectToError(reason.code);
                            break;
                    }
                }
            });
        });
    };
    BBCsrfXhr.postWithCSRF = function (url) {
        return new Promise(function (resolve, reject) {
            // First get the CSRF token
            new Promise(function (resolveCsrf, rejectCsrf) {
                requestToken(auth_domain_1.BBAuthDomain.getSTSDomain() + '/session/csrf', 'token_needed')
                    .then(resolveCsrf)
                    .catch(rejectCsrf);
            })
                .then(function (csrfResponse) {
                // Next issue the request with the csrf token
                return new Promise(function (res, rej) {
                    post(url, {
                        name: 'X-CSRF',
                        value: csrfResponse['csrf_token'],
                    }, undefined, function (result) {
                        res(result);
                    }, rej);
                });
            })
                .then(resolve)
                .catch(function (reason) {
                if (reason.code === auth_1.BBAuthTokenErrorCode.Offline) {
                    reject(reason);
                }
                else {
                    switch (reason.code) {
                        case auth_1.BBAuthTokenErrorCode.NotLoggedIn:
                            navigator_1.BBAuthNavigator.redirectToSignin();
                            break;
                        default:
                            navigator_1.BBAuthNavigator.redirectToError(reason.code);
                            break;
                    }
                }
            });
        });
    };
    BBCsrfXhr.requestWithToken = function (url, token, verb, body) {
        if (verb === void 0) { verb = 'GET'; }
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    switch (xhr.status) {
                        case 200:
                            var result = void 0;
                            if (xhr.responseText) {
                                result = JSON.parse(xhr.responseText);
                            }
                            resolve(result);
                            break;
                        default:
                            reject(xhr);
                            break;
                    }
                }
            };
            xhr.open(verb, url, true);
            xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            xhr.setRequestHeader('Accept', 'application/json');
            switch (verb) {
                case 'GET':
                    xhr.send();
                    break;
                case 'PATCH':
                case 'POST':
                    xhr.setRequestHeader('Content-Type', 'application/json');
                    xhr.send(JSON.stringify(body));
                    break;
            }
        });
    };
    return BBCsrfXhr;
}());
exports.BBCsrfXhr = BBCsrfXhr;
